import { render, staticRenderFns } from "./vcDropzone.vue?vue&type=template&id=33b8d6d6&"
import script from "./vcDropzone.vue?vue&type=script&lang=js&"
export * from "./vcDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports